import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Book.css';
import cx from 'classnames';

import Loader from '../../components/Loader/Loader';
//import history from '../../core/history';
// Component
import Booking from '../../components/Booking';

//Images
import BgImage from '../../../public/SiteImages/newsBoxBg.png';

class Book extends Component {
    static propTypes = {
      listId: PropTypes.any,
      loading: PropTypes.bool
    };

    /* componentDidMount() {
      if( this.props.loading ) {
        history.push('/book/' + this.props.listId + '?referred=1');
      }
    } */

    render() {
      const { originalIsAuthenticated, loading, loggedIn } = this.props;
      return (
        <React.Fragment>
        {
          loading ? <Loader show={loading} type={"page"} /> :
          <div className={s.container}>
            <div className={cx(s.landingContainer, s.bgImageSection)}>
              <div className={s.bgImage} style={{ backgroundImage: `url(${BgImage})` }} />
              <Booking originalIsAuthenticated={originalIsAuthenticated} />
            </div>
          </div>
        }
        </React.Fragment>
      );
    }
}

export default withStyles(s)(Book);


// WEBPACK FOOTER //
// src/routes/book/Book.js